import { Icon, IconProps } from "@chakra-ui/react"

const GreenCheckedIcon = ({
  fillColor = "#51FF00",
  ...props
}: IconProps & { fillColor?: string }) => (
  <Icon
    width='20px'
    height='20px'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17316C0.00433283 8.00043 -0.1937 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8078C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 7.34783 18.9464 4.80429 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0ZM8.57143 13.9929L5 10.4214L6.13572 9.28571L8.57143 11.7214L13.8643 6.42857L15.0043 7.56143L8.57143 13.9929Z'
      fill={fillColor}
    />
  </Icon>
)
export default GreenCheckedIcon
